export default {
	errorTitle: 'Une erreur est survenue',
	errorText:
		"Le lien permettant la confirmation de votre compte est incorrect ou n'est plus valide. Veuillez contacter le support.",
	validatedTitle: 'Confirmation',
	validatedText:
		'Veuillez renseigner un mot de passe afin de pouvoir vous connecter à la plateforme Hubeeconnect.',
	acceptCGU: "J'ai lu et j'accepte les CGU",
}
